import { Button, DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManageRecurringPayAdjustments extends Layout {
    buttonGeneratePayAdjustments: Button;
    buttonSearch: Button;
    panelSearchContainer: Panel;
    sourceManageRecurringPayAdjustments: DataSource;
    tableManageRecurring: Table;
    textboxDate: Textbox;
}
